import React, { useEffect, useState, useRef } from "react";
import "jsvectormap/dist/maps/world.js";
import 'jsvectormap/dist/jsvectormap.min.css';

import { Card, CardBody } from "../../components/card/card.jsx";

import Chart from "chart.js/auto";

import "bootstrap-daterangepicker/daterangepicker.css";

import "react-datepicker/dist/react-datepicker.css";

import DateTime from "react-datetime";
import "react-datetime/css/react-datetime.css";

import UserExpand from "./expand/userexpand.jsx";
import CuratedRecipeExpand from "./expand/curatedrecipeexpand.jsx";
import CustomRecipeExpand from "./expand/customrecipeexpand.jsx";
import MakeRecipeExpand from "./expand/makerecipeexpand.jsx";
import LikeRecipeExpand from "./expand/likerecipeexpand.jsx";
import ViewRecipeExpand from "./expand/viewrecipeexpand.jsx";
import BrandRecipeExpand from "./expand/brandrecipeexpand.jsx";
import BlogRecipeExpand from "./expand/blogrecipeexpand.jsx";
import BrandcategoryRecipeExpand from "./expand/brandcategoryexpand.jsx";
import ScheduleRecipeExpand from "./expand/schedulerecipeexpand.jsx";
import BlognewsRecipeExpand from "./expand/blognewsrecipeexpand.jsx";
import NotificationRecipeExpand from "./expand/notificationrecipeexpand.jsx";
import { useDispatch, useSelector } from "react-redux";
import { 
        fetchAdminUserStats,
        fetchAdminRecipesStats,
        fetchAdminCustomRecipesStats,
        fetchAdminMakeRecipesStats,
        fetchAdminLikeRecipesStats,
        fetchAdminViewRecipesStats,
        fetchAdminBrandsStats,
        fetchAdminBrandCategoryStats,
        fetchAdminBarsStats,
        fetchAdminBlogStats,
        fetchAdminBlogNewsStats
      } from "../../actions/dashboardadmin_actions";

import DatePicker from "react-datepicker";

import { ModalComponent } from "../expand/expandmodal.jsx";

import "datatables.net-bs5/css/dataTables.bootstrap5.min.css";
import "datatables.net-responsive-bs5/css/responsive.bootstrap5.min.css";
import "datatables.net-fixedcolumns-bs5/css/fixedColumns.bootstrap5.min.css";
import "datatables.net-buttons-bs5/css/buttons.bootstrap5.min.css";

const $ = require("jquery");
$.DataTable = require("datatables.net");
require("datatables.net-bs5");
require("datatables.net-buttons");
require("datatables.net-buttons/js/buttons.colVis.min.js");
// require("datatables.net-buttons/js/buttons.flash.min.js");
require("datatables.net-buttons/js/buttons.html5.min.js");
require("datatables.net-buttons/js/buttons.print.min.js");
require("datatables.net-buttons-bs5");
require("datatables.net-responsive");
require("datatables.net-responsive-bs5");
require("datatables.net-fixedcolumns");
require("datatables.net-fixedcolumns-bs5");

const Dashboardadmindata = () => {
  const dispatch = useDispatch();
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);

  // Pull "user" stats state from Redux
  const {
    adminStats: userStats,
    loadingAdminStats: userLoading,
    adminStatsError: userError
  } = useSelector((state) => state.dashboardadmin);

  // Curated Recipe selector
  const {
     curatedRecipesStats,
    loadingCuratedRecipesStats,
    curatedRecipesStatsError
  } = useSelector((state) => state.dashboardadmin);

  // Custom Recipe (Redux)
  const {
    customRecipesStats,
    loadingCustomRecipesStats,
    customRecipesStatsError
  } = useSelector((state) => state.dashboardadmin);

  // ── Total Makes (Redux) ─────────────────────────
  const {
    makeRecipesStats,
    loadingMakeRecipesStats,
    makeRecipesStatsError
  } = useSelector((state) => state.dashboardadmin);

  // Total Likes - (Redux)
  const {
    likeRecipesStats,
    loadingLikeRecipesStats,
    likeRecipesStatsError
  } = useSelector((state) => state.dashboardadmin);

  // Total View (Redux)
  const {
    viewRecipesStats,
    loadingViewRecipesStats,
    viewRecipesStatsError
  } = useSelector(state => state.dashboardadmin);

  // Brand (Redux)
  const {
    brandsStats,
    loadingBrandsStats,
    brandsStatsError
  } = useSelector((state) => state.dashboardadmin);

  // Brand Category - (Redux)
  const {
    brandCategoryStats,
    loadingBrandCategoryStats,
    brandCategoryStatsError
  } = useSelector((state) => state.dashboardadmin);

  // Bars - (Redux)
  const {
    barsStats,
    loadingBarsStats,
    barsStatsError
  } = useSelector((state) => state.dashboardadmin);

  // Blog/News - (Redux)
  const {
    blogStats,
    loadingBlogStats,
    blogStatsError
  } = useSelector((state) => state.dashboardadmin);

  // Blog/News View Statistic - (Redux)
  const {
    blogNewsStats,
    loadingBlogNewsStats,
    blogNewsStatsError
  } = useSelector((state) => state.dashboardadmin);




  // Search Trigger
  const [searchTriggered, setSearchTriggered] = useState(false);

    // Compute Unix timestamps
  const getTimestamps = () => ({
    startTime: fromDate ? Math.floor(fromDate.getTime() / 1000) : 0,
    endTime:   toDate   ? Math.floor(toDate.getTime()   / 1000) : Math.floor(Date.now() / 1000)
  });

  //User
  // const [data, setData] = useState(null);
  // const [labels, setLabels] = useState([]);
  // const [values, setValues] = useState([]);

  //Curated Recipe
  // const [curatedrecipedata, setCuratedRecipeData] = useState(null);
  // const [curatedrecipelabels, setcuratedrecipeLabels] = useState([]);
  // const [curatedrecipevalues, setcuratedrecipeValues] = useState([]);

  //Custom Recipe
  // const [customrecipedata, setCustomRecipeData] = useState(null);
  // const [customrecipelabels, setcustomrecipeLabels] = useState([]);
  // const [customrecipevalues, setcustomrecipeValues] = useState([]);

  //Make Recipe
  // const [makerecipedata, setMakeRecipeData] = useState(null);
  // const [makerecipelabels, setmakerecipeLabels] = useState([]);
  // const [makerecipevalues, setmakerecipeValues] = useState([]);

  //Like Recipe
  // const [likerecipedata, setLikeRecipeData] = useState(null);
  // const [likerecipelabels, setlikerecipeLabels] = useState([]);
  // const [likerecipevalues, setlikerecipeValues] = useState([]);

  //View Recipe
  // const [viewrecipedata, setViewRecipeData] = useState(null);
  // const [viewrecipelabels, setviewrecipeLabels] = useState([]);
  // const [viewrecipevalues, setviewrecipeValues] = useState([]);

  //Brand Recipe
  // const [brandrecipedata, setBrandRecipeData] = useState(null);
  // const [brandrecipelabels, setbrandrecipeLabels] = useState([]);
  // const [brandrecipevalues, setbrandrecipeValues] = useState([]);

  //Blog Recipe
  // const [blogrecipedata, setBlogRecipeData] = useState(null);
  // const [blogrecipelabels, setblogrecipeLabels] = useState([]);
  // const [blogrecipevalues, setblogrecipeValues] = useState([]);

  //Brand Category Recipe
  // const [brandcategoryrecipedata, setBrandcategoryRecipeData] = useState(null);
  // const [brandcategoryrecipelabels, setbrandcategoryrecipeLabels] = useState(
  //   []
  // );
  // const [brandcategoryrecipevalues, setbrandcategoryrecipeValues] = useState(
  //   []
  // );


  // Schedule Notification
  // const [schedulenotificationrecipedata, setSchedulenotificationRecipeData] = useState(null);
  // const [schedulenotificationrecipelabels, setschedulenotificationrecipeLabels] = useState([]);
  // const [schedulenotificationrecipevalues, setschedulenotificationrecipeValues] = useState([]);

    // Schedule Notification
    // const [blogstatisticsrecipedata, setBlogstatisticsRecipeData] = useState(null);
    // const [blogstatisticsrecipelabels, setblogstatisticsrecipeLabels] = useState([]);
    // const [blogstatisticsrecipevalues, setblogstatisticsrecipeValues] = useState([]);

    //  Notification Statistics
    // const [notificationrecipedata, setNotificationRecipeData] = useState(null);
    // const [notificationrecipelabels, setnotificationrecipeLabels] = useState([]);
    // const [notificationrecipevalues, setnotificationrecipeValues] = useState([]);

  // color & font variable
  var gray300Color = getComputedStyle(document.body)
    .getPropertyValue("--bs-gray-300")
    .trim();
  var gray300RgbColor = getComputedStyle(document.body)
    .getPropertyValue("--bs-gray-300-rgb")
    .trim();
  var indigoColor = getComputedStyle(document.body)
    .getPropertyValue("--bs-indigo")
    .trim();
  var bodyColor = getComputedStyle(document.body)
    .getPropertyValue("--bs-body-color")
    .trim();
  var bodyBg = getComputedStyle(document.body)
    .getPropertyValue("--bs-body-bg")
    .trim();
  var borderColor = getComputedStyle(document.body)
    .getPropertyValue("--bs-border-color")
    .trim();
  var bodyFontFamily = getComputedStyle(document.body)
    .getPropertyValue("--bs-body-font-family")
    .trim();
  var bodyFontWeight = getComputedStyle(document.body)
    .getPropertyValue("--bs-body-font-weight")
    .trim();
  var inverse = getComputedStyle(document.body)
    .getPropertyValue("--bs-inverse")
    .trim();
  var themeColor = getComputedStyle(document.body)
    .getPropertyValue("--bs-theme")
    .trim();

  // chart global options
  Chart.defaults.font.family = bodyFontFamily;
  Chart.defaults.font.size = 12;
  Chart.defaults.color = bodyColor;
  Chart.defaults.borderColor = borderColor;
  Chart.defaults.plugins.legend.display = false;
  Chart.defaults.plugins.tooltip.padding = {
    left: 8,
    right: 12,
    top: 8,
    bottom: 8,
  };
  Chart.defaults.plugins.tooltip.cornerRadius = 8;
  Chart.defaults.plugins.tooltip.titleMarginBottom = 6;
  Chart.defaults.plugins.tooltip.color = bodyBg;
  Chart.defaults.plugins.tooltip.multiKeyBackground = inverse;
  Chart.defaults.plugins.tooltip.backgroundColor = "black";
  Chart.defaults.plugins.tooltip.titleFont.family = bodyFontFamily;
  Chart.defaults.plugins.tooltip.titleFont.weight = bodyFontWeight;
  Chart.defaults.plugins.tooltip.footerFont.family = bodyFontFamily;
  Chart.defaults.plugins.tooltip.displayColors = true;
  Chart.defaults.plugins.tooltip.boxPadding = 6;
  Chart.defaults.scale.grid.color = borderColor;
  Chart.defaults.scale.beginAtZero = true;
  //  Chart.defaults.maintainAspectRatio = false;

  var themeFont = getComputedStyle(document.body)
    .getPropertyValue("--bs-body-font-family")
    .trim();
  var themeFontWeight = getComputedStyle(document.body)
    .getPropertyValue("--bs-body-font-weight")
    .trim();
  var gray500 = getComputedStyle(document.body)
    .getPropertyValue("--bs-gray-500")
    .trim();
  var orange = getComputedStyle(document.body)
    .getPropertyValue("--bs-theme")
    .trim();
  var inverse = getComputedStyle(document.body)
    .getPropertyValue("--bs-inverse")
    .trim();
  var inverseRgb = getComputedStyle(document.body)
    .getPropertyValue("--bs-inverse-rgb")
    .trim();
  var borderColor = getComputedStyle(document.body)
    .getPropertyValue("--bs-border-color")
    .trim();
  var indigo = getComputedStyle(document.body)
    .getPropertyValue("--bs-indigo")
    .trim();

  // const getTimestamps = () => ({
  //   startTime: fromDate ? Math.floor(fromDate.getTime() / 1000) : 0,
  //   endTime: toDate
  //     ? Math.floor(toDate.getTime() / 1000)
  //     : Math.floor(new Date().getTime() / 1000),
  // });

    // Whenever searchTriggered or date changes, dispatch our Redux action
  useEffect(() => {
    const { startTime, endTime } = getTimestamps();
    dispatch(fetchAdminUserStats(startTime, endTime, "user"));
    dispatch(fetchAdminRecipesStats(startTime, endTime));
    dispatch(fetchAdminCustomRecipesStats(startTime, endTime));
    dispatch(fetchAdminMakeRecipesStats(startTime, endTime));
    dispatch(fetchAdminLikeRecipesStats(startTime, endTime));
    dispatch(fetchAdminViewRecipesStats(startTime, endTime));
    dispatch(fetchAdminBrandsStats(startTime, endTime));
    dispatch(fetchAdminBrandCategoryStats(startTime, endTime));
    dispatch(fetchAdminBarsStats(startTime, endTime));
    dispatch(fetchAdminBlogStats(startTime, endTime));
    dispatch(fetchAdminBlogNewsStats(startTime, endTime));
  }, [dispatch, searchTriggered]);

  // Derive labels/values from Redux payload
  const userLabels = userStats?.dateswise?.map((d) => d.label) || [];
  const userValues = userStats?.dateswise?.map((d) => d.value) || [];

  // curated recipe
  const curatedLabels = curatedRecipesStats?.dateswise?.map((d) => d.label) || [];
  const curatedValues = curatedRecipesStats?.dateswise?.map((d) => d.value) || [];

  // Custom
  const customLabels = customRecipesStats?.dateswise?.map(d => d.label) || [];
  const customValues = customRecipesStats?.dateswise?.map(d => d.value) || [];

  // Total Makes
  const makeLabels = makeRecipesStats?.dateswise?.map(d => d.label) || [];
  const makeValues = makeRecipesStats?.dateswise?.map(d => d.value) || [];

  // Total Likes
  const likeLabels = likeRecipesStats?.dateswise?.map(d => d.label) || [];
  const likeValues = likeRecipesStats?.dateswise?.map(d => d.value) || [];  

  // Total View
  const viewLabels = viewRecipesStats?.dateswise?.map(d => d.label) || [];
  const viewValues = viewRecipesStats?.dateswise?.map(d => d.value) || [];  
  
  // Brand
  const brandsLabels = brandsStats?.dateswise?.map((d) => d.label) || [];
  const brandsValues = brandsStats?.dateswise?.map((d) => d.value) || [];

  // Brand Category
  const brandCategoryLabels = brandCategoryStats?.dateswise?.map((d) => d.label) || [];
  const brandCategoryValues = brandCategoryStats?.dateswise?.map((d) => d.value) || [];

  // Bars
  const barsLabels = barsStats?.dateswise?.map((d) => d.label) || [];
  const barsValues = barsStats?.dateswise?.map((d) => d.value) || [];

  // Blog/News
  const blogLabels = blogStats?.dateswise?.map(d => d.label) || [];
  const blogValues = blogStats?.dateswise?.map(d => d.value) || [];

  // Blog/News View Statistic
  const blogNewsLabels = blogNewsStats?.dateswise?.map(d => d.label) || [];
  const blogNewsValues = blogNewsStats?.dateswise?.map(d => d.value) || [];

  var themeColor = getComputedStyle(document.body)
    .getPropertyValue("--bs-theme")
    .trim();
  var themeColorRgb = getComputedStyle(document.body)
    .getPropertyValue("--bs-theme-rgb")
    .trim();
  var bodyBg = getComputedStyle(document.body)
    .getPropertyValue("--bs-body-bg")
    .trim();

  // const handleSearch = () => {
  //   setSearchTriggered((prev) => !prev); // Toggle searchTriggered to re-trigger fetching
  // };

  useEffect(() => {
  if (!searchTriggered) return;      
      // bail out until user clicks
    const { startTime, endTime } = getTimestamps();

      dispatch(fetchAdminUserStats(startTime, endTime, "user"));
      dispatch(fetchAdminRecipesStats(startTime, endTime));
      dispatch(fetchAdminCustomRecipesStats(startTime, endTime));
      dispatch(fetchAdminMakeRecipesStats(startTime, endTime));
      dispatch(fetchAdminLikeRecipesStats(startTime, endTime));
      dispatch(fetchAdminViewRecipesStats(startTime, endTime));
      dispatch(fetchAdminBrandsStats(startTime, endTime));
      dispatch(fetchAdminBrandCategoryStats(startTime, endTime));
      dispatch(fetchAdminBlogStats(startTime, endTime));
      dispatch(fetchAdminBlogNewsStats(startTime, endTime));

}, [dispatch, searchTriggered]);

// 1) Extract all dispatch calls into one function
  const doFetch = () => {
    const { startTime, endTime } = getTimestamps();

    dispatch(fetchAdminUserStats(startTime, endTime, 'user'));
    dispatch(fetchAdminRecipesStats(startTime, endTime));
    dispatch(fetchAdminCustomRecipesStats(startTime, endTime));
    dispatch(fetchAdminMakeRecipesStats(startTime, endTime));
    dispatch(fetchAdminLikeRecipesStats(startTime, endTime));
    dispatch(fetchAdminViewRecipesStats(startTime, endTime));
    dispatch(fetchAdminBrandsStats(startTime, endTime));
    dispatch(fetchAdminBrandCategoryStats(startTime, endTime));
    dispatch(fetchAdminBarsStats(startTime, endTime));
    dispatch(fetchAdminBlogStats(startTime, endTime));
    dispatch(fetchAdminBlogNewsStats(startTime, endTime));
  };

  // 2) Run once on mount
  useEffect(() => {
    doFetch();
  }, [dispatch]);

  // 3) Call it again when the user clicks Search
  const handleSearch = () => {
    doFetch();
  };


  return (
    <div className="row">
      {/* Filters */}
      <div className="row gy-2 gx-2 align-items-end mb-3">
        {/* From */}
        <div className="col-12 col-sm-6 col-lg-3">
          <label className="form-label">Date From</label>
          <DatePicker
            selected={fromDate}
            onChange={setFromDate}
            className="form-control"
            placeholderText="mm/dd/yyyy"
            showPopperArrow={false}

            /* make the calendar render to <body> and sit above everything */
            portalId="datepickers-portal"
            popperClassName="dp-popper"
            calendarClassName="dp-calendar"
            popperPlacement="bottom-start"
          />
        </div>

        {/* To */}
        <div className="col-12 col-sm-6 col-lg-3">
          <label className="form-label">Date To</label>
          <DatePicker
            selected={toDate}
            onChange={setToDate}
            className="form-control"
            placeholderText="mm/dd/yyyy"

            portalId="datepickers-portal"
            popperClassName="dp-popper"
            calendarClassName="dp-calendar"
            popperPlacement="bottom-start"
          />
        </div>

        {/* Apply */}
        <div className="col-12 col-md-4 col-lg-auto">
          <button
            onClick={handleSearch}
            className="btn btn-secondary w-100 ms-lg-2"
            type="button"
            title="Apply date filters"
          >
            <i className="fas fa-search" />
            {/* <span className="d-none d-md-inline ms-2">Apply</span> */}
          </button>
        </div>
      </div>



      {/* User- Start*/}
       <div className="col-xl-4 col-lg-6">
        <Card className="mb-3">
          <CardBody>
            <div className="d-flex fw-bold small">
              <h6 className="flex-grow-1">Users</h6>
              <ModalComponent
                cardBodyContent={
                  <UserExpand
                    data={userStats}
                    labels={userLabels}
                    values={userValues}
                    themeColor={themeColor}
                    themeColorRgb={themeColorRgb}
                    bodyBg={bodyBg}
                  />
                }
              />
            </div>
            <div className="row align-items-center">
              <div className="col-5 mt-3 mb-3">
                <h3 className="mb-0">
                  {userLoading ? (
                    <div className="spinner-border" style={{ color: themeColor }} />
                  ) : (
                    // show total or 0 if absent
                    userStats.total ?? 0
                  )}
                </h3>
              </div>
              <div className="col-7 mt-3"></div>
            </div>
            {userError && (
              <div className="text-danger small mt-2">Error: {userError}</div>
            )}
          </CardBody>
        </Card>
      </div>
      {/* User- Ends*/}

      {/* Curated Recipe Card */}
      <div className="col-xl-4 col-lg-6">
        <Card className="mb-3">
          <CardBody>
            <div className="d-flex fw-bold small">
              <h6 className="flex-grow-1">Curated Recipes</h6>
              <ModalComponent
                cardBodyContent={
                  <CuratedRecipeExpand
                    data={curatedRecipesStats}
                    labels={curatedLabels}
                    values={curatedValues}
                    themeColor={themeColor}
                    themeColorRgb={themeColorRgb}
                    bodyBg={bodyBg}
                  />
                }
              />
            </div>

            <div className="row align-items-center">
              <div className="col-5 mt-3 mb-3">
                <h3 className="mb-0">
                  {loadingCuratedRecipesStats
                    ? <div className="spinner-border" style={{ color: themeColor }} />
                    : curatedRecipesStats.total ?? 0
                  }
                </h3>
              </div>
              <div className="col-7 mt-3"></div>
            </div>

            {curatedRecipesStatsError && (
              <div className="text-danger small mt-2">
                Error: {curatedRecipesStatsError}
              </div>
            )}
          </CardBody>
        </Card>
      </div>
      {/* Curated Recipe - Ends}

      
      {/* Custom Recipe - Start (Redux) */}
      <div className="col-xl-4 col-lg-6">
        <Card className="mb-3">
          <CardBody>
            <div className="d-flex fw-bold small">
              <h6 className="flex-grow-1">Custom Recipes</h6>
              <ModalComponent
                cardBodyContent={
                  <CustomRecipeExpand
                    data={customRecipesStats}
                    labels={customLabels}
                    values={customValues}
                    themeColor={themeColor}
                    themeColorRgb={themeColorRgb}
                    bodyBg={bodyBg}
                  />
                }
              />
            </div>

            <div className="row align-items-center">
              <div className="col-5 mt-3 mb-3">
                <h3 className="mb-0">
                  {loadingCustomRecipesStats
                    ? <div className="spinner-border" style={{ color: themeColor }} />
                    : customRecipesStats.total ?? 0
                  }
                </h3>
              </div>
              <div className="col-7 mt-3"></div>
            </div>

            {customRecipesStatsError && (
              <div className="text-danger small mt-2">
                Error: {customRecipesStatsError}
              </div>
            )}
          </CardBody>
        </Card>
      </div>
      {/* Custom Recipe - Ends (Redux) */}


      {/* Total Makes - Start (Redux) */}
      <div className="col-xl-4 col-lg-6">
        <Card className="mb-3">
          <CardBody>
            <div className="d-flex fw-bold small">
              <h6 className="flex-grow-1">Total Makes</h6>
              <ModalComponent
                cardBodyContent={
                  <MakeRecipeExpand
                    data={makeRecipesStats}
                    labels={makeLabels}
                    values={makeValues}
                    themeColor={themeColor}
                    themeColorRgb={themeColorRgb}
                    bodyBg={bodyBg}
                  />
                }
              />
            </div>

            <div className="row align-items-center">
              <div className="col-5 mt-3 mb-3">
                <h3 className="mb-0">
                  {loadingMakeRecipesStats
                    ? <div className="spinner-border" style={{ color: themeColor }} />
                    : makeRecipesStats.total ?? 0
                  }
                </h3>
              </div>
              <div className="col-7 mt-3"></div>
            </div>

            {makeRecipesStatsError && (
              <div className="text-danger small mt-2">
                Error: {makeRecipesStatsError}
              </div>
            )}
          </CardBody>
        </Card>
      </div>
      {/* Total Makes - Ends (Redux) */}

      {/* Total Like - Start (Redux) */}
      <div className="col-xl-4 col-lg-6">
        <Card className="mb-3">
          <CardBody>
            <div className="d-flex fw-bold small">
              <h6 className="flex-grow-1">Total Likes</h6>
              <ModalComponent
                cardBodyContent={
                  <LikeRecipeExpand
                    data={likeRecipesStats}
                    labels={likeLabels}
                    values={likeValues}
                    themeColor={themeColor}
                    themeColorRgb={themeColorRgb}
                    bodyBg={bodyBg}
                  />
                }
              />
            </div>

            <div className="row align-items-center">
              <div className="col-5 mt-3 mb-3">
                <h3 className="mb-0">
                  {loadingLikeRecipesStats
                    ? <div className="spinner-border" style={{ color: themeColor }} />
                    : likeRecipesStats.total ?? 0
                  }
                </h3>
              </div>
              <div className="col-7 mt-3"></div>
            </div>

            {likeRecipesStatsError && (
              <div className="text-danger small mt-2">
                Error: {likeRecipesStatsError}
              </div>
            )}
          </CardBody>
        </Card>
      </div>
      {/* Total Like - Ends (Redux) */}

      {/* Total View - Start (Redux) */}
      <div className="col-xl-4 col-lg-6">
        <Card className="mb-3">
          <CardBody>
            <div className="d-flex fw-bold small">
              <h6 className="flex-grow-1">Total Views</h6>
              <ModalComponent
                cardBodyContent={
                  <ViewRecipeExpand
                    data={viewRecipesStats}
                    labels={viewLabels}
                    values={viewValues}
                    themeColor={themeColor}
                    themeColorRgb={themeColorRgb}
                    bodyBg={bodyBg}
                  />
                }
              />
            </div>

            <div className="row align-items-center">
              <div className="col-5 mt-3 mb-3">
                <h3 className="mb-0">
                  {loadingViewRecipesStats
                    ? <div className="spinner-border" style={{ color: themeColor }} />
                    : viewRecipesStats.total ?? 0
                  }
                </h3>
              </div>
              <div className="col-7 mt-3"></div>
            </div>

            {viewRecipesStatsError && (
              <div className="text-danger small mt-2">
                Error: {viewRecipesStatsError}
              </div>
            )}
          </CardBody>
        </Card>
      </div>
      {/* Total View - Ends (Redux) */}

      {/* Brand - Start (Redux) */}
      <div className="col-xl-4 col-lg-6">
        <Card className="mb-3">
          <CardBody>
            <div className="d-flex fw-bold small">
              <h6 className="flex-grow-1">Brands</h6>
              <ModalComponent
                cardBodyContent={
                  <BrandRecipeExpand
                    data={brandsStats}
                    labels={brandsLabels}
                    values={brandsValues}
                    themeColor={themeColor}
                    themeColorRgb={themeColorRgb}
                    bodyBg={bodyBg}
                  />
                }
              />
            </div>

            <div className="row align-items-center">
              <div className="col-5 mt-3 mb-3">
                <h3 className="mb-0">
                  {loadingBrandsStats
                    ? <div className="spinner-border" style={{ color: themeColor }} />
                    : brandsStats.total ?? 0
                  }
                </h3>
              </div>
              <div className="col-7 mt-3"></div>
            </div>

            {brandsStatsError && (
              <div className="text-danger small mt-2">
                Error: {brandsStatsError}
              </div>
            )}
          </CardBody>
        </Card>
      </div>
      {/* Brand - Ends (Redux) */}

      {/* Brand Category - Start (Redux) */}
      <div className="col-xl-4 col-lg-6">
        <Card className="mb-3">
          <CardBody>
            <div className="d-flex fw-bold small">
              <h6 className="flex-grow-1">Brand Categories</h6>
              <ModalComponent
                cardBodyContent={
                  <BrandcategoryRecipeExpand
                    data={brandCategoryStats}
                    labels={brandCategoryLabels}
                    values={brandCategoryValues}
                    themeColor={themeColor}
                    themeColorRgb={themeColorRgb}
                    bodyBg={bodyBg}
                  />
                }
              />
            </div>

            <div className="row align-items-center">
              <div className="col-5 mt-3 mb-3">
                <h3 className="mb-0">
                  {loadingBrandCategoryStats
                    ? <div className="spinner-border" style={{ color: themeColor }} />
                    : brandCategoryStats.total ?? 0
                  }
                </h3>
              </div>
              <div className="col-7 mt-3"></div>
            </div>

            {brandCategoryStatsError && (
              <div className="text-danger small mt-2">
                Error: {brandCategoryStatsError}
              </div>
            )}
          </CardBody>
        </Card>
      </div>
      {/* Brand Category - Ends (Redux) */}

      {/* Bars - Start (Redux) */}
      <div className="col-xl-4 col-lg-6">
        <Card className="mb-3">
          <CardBody>
            <div className="d-flex fw-bold small">
              <h6 className="flex-grow-1">Bars</h6>
            </div>

            <div className="row align-items-center">
              <div className="col-5 mt-3 mb-3">
                <h3 className="mb-0">
                  {loadingBarsStats
                    ? <div className="spinner-border" style={{ color: themeColor }} />
                    : barsStats.total ?? 0
                  }
                </h3>
              </div>
              <div className="col-7 mt-3"></div>
            </div>

            {barsStatsError && (
              <div className="text-danger small mt-2">
                Error: {barsStatsError}
              </div>
            )}
          </CardBody>
        </Card>
      </div>
      {/* Bars - Ends (Redux) */}

      {/* Blog/News - Start (Redux) */}
      <div className="col-xl-4 col-lg-6">
        <Card className="mb-3">
          <CardBody>
            <div className="d-flex fw-bold small">
              <h6 className="flex-grow-1">Blog/News</h6>
              <ModalComponent
                cardBodyContent={
                  <BlogRecipeExpand
                    data={blogStats}
                    labels={blogLabels}
                    values={blogValues}
                    themeColor={themeColor}
                    themeColorRgb={themeColorRgb}
                    bodyBg={bodyBg}
                  />
                }
              />
            </div>

            <div className="row align-items-center">
              <div className="col-5 mt-3 mb-3">
                <h3 className="mb-0">
                  {loadingBlogStats
                    ? <div className="spinner-border" style={{ color: themeColor }} />
                    : blogStats.total ?? 0
                  }
                </h3>
              </div>
              <div className="col-7 mt-3"></div>
            </div>

            {blogStatsError && (
              <div className="text-danger small mt-2">
                Error: {blogStatsError}
              </div>
            )}
          </CardBody>
        </Card>
      </div>
      {/* Blog/News - Ends (Redux) */}


      {/* Blog/News View Statistic - Start (Redux) */}
      <div className="col-xl-4 col-lg-6">
        <Card className="mb-3">
          <CardBody>
            <div className="d-flex fw-bold small">
              <h6 className="flex-grow-1">Blog/News View Statistics</h6>
              <ModalComponent
                cardBodyContent={
                  <BlognewsRecipeExpand
                    data={blogNewsStats}
                    labels={blogNewsLabels}
                    values={blogNewsValues}
                    themeColor={themeColor}
                    themeColorRgb={themeColorRgb}
                    bodyBg={bodyBg}
                  />
                }
              />
            </div>

            <div className="row align-items-center">
              <div className="col-5 mt-3 mb-3">
                <h3 className="mb-0">
                  {loadingBlogNewsStats
                    ? <div className="spinner-border" style={{ color: themeColor }} />
                    : blogNewsStats.total ?? 0
                  }
                </h3>
              </div>
              <div className="col-7 mt-3"></div>
            </div>

            {blogNewsStatsError && (
              <div className="text-danger small mt-2">
                Error: {blogNewsStatsError}
              </div>
            )}
          </CardBody>
        </Card>
      </div>
      {/* Blog/News View Statistic - Ends (Redux) */}
    </div>
  );
};

export default Dashboardadmindata;
